import Awaiters from "../../LTGame/Async/Awaiters";
import MonoHelper, { EActionType } from "../../LTGame/LTUtils/MonoHelper";
import { P2Manager } from "../../LTGame/Physics/P2Manager";
import LTPlatform from "../../LTGame/Platform/LTPlatform";
import LTRes from "../../LTGame/Res/LTRes";
import LTUI from "../../LTGame/UIExt/LTUI";
import { LTG_Com_ShareVideoData } from "../../LTG_CommonUI/Data/LTG_Com_ShareVideoData";
import { EGameState } from "../common/EGameState";
import { ELoadTye } from "../common/ELoadType";
import GameData from "../common/GameData";
import GlobalUnit from "../common/GlobalUnit";
import ResDefine from "../common/ResDefine";
import { PetConfig } from "../config/PetConfig";
import CameraControl from "../logic/CameraControl";
import PlayerLogic, { EPlayerState } from "../logic/play/PlayerLogic";
import ViewLevel from "../logic/ViewLevel";
import ViewPet from "../logic/ViewPet";
import { UI_FailMediator } from "../ui/UI_FailMediator";
import { UI_FightMediator } from "../ui/UI_FightMediator";
import { UI_GetMediator } from "../ui/UI_GetMediator";
import { UI_MainMediator } from "../ui/UI_MainMediator";
import { UI_ReviveMediator } from "../ui/UI_ReviveMediator";
import { UI_SkillMediator } from "../ui/UI_SkillMediator";
import { UI_WinMediator } from "../ui/UI_WinMediator";
import MaterialManager from "./MaterialManager";
import TextManager from "./TextManager";
import UI_LoadMediator from "../ui/UI_LoadMediator";
import AudioManager from "./AudioManager";
export var EResultType;
(function (EResultType) {
    EResultType[EResultType["Win"] = 0] = "Win";
    EResultType[EResultType["Fail"] = 1] = "Fail";
})(EResultType || (EResultType = {}));
export default class GameManager {
    constructor() {
        this.gameCount = 0;
        this.paused = false;
        this.player = new PlayerLogic();
        this.level = new ViewLevel();
        this.level.SetLevelId(GameData.instance.levelId);
        this.player.SetPlayerId(GlobalUnit.dataManager.tryRoleId);
        this.camera = new CameraControl();
        this.text = new TextManager();
        this.pet = new ViewPet();
        MonoHelper.instance.AddAction(EActionType.Update, this, this.Update);
        MonoHelper.instance.AddAction(EActionType.LateUpdate, this, this.LateUpdate);
        P2Manager.CreateInstance();
    }
    PreLoad(urls) {
        this.level.PreLoad(urls);
        this.player.PreLoad(urls);
        urls.push(ResDefine.FixPath(ResDefine.HpPath));
        this.text.PreLoad(urls);
        MaterialManager.instance.PreLoad(urls);
    }
    StartGame() {
        this.gameCount++;
        UI_MainMediator.instance.Hide();
        UI_FightMediator.instance.Show();
        this.state = EGameState.Fight;
        this.player.StartGame();
        LTPlatform.instance.RecordEvent('game_start', { level_id: GameData.instance.levelId });
        LTPlatform.instance.recordManager.StartRecord(null, null);
        AudioManager.instance.PlayById(10);
    }
    GoToHome() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.CreateLevel(ELoadTye.Next);
            UI_MainMediator.instance.Show();
            UI_FightMediator.instance.Hide();
        });
    }
    ResetGame() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.level.config.level_type == 2 || this.level.config.level_type == 3 || this.level.config.level_type == 4) {
                yield this.CreateLevel(ELoadTye.Next);
            }
            else {
                yield this.CreateLevel(ELoadTye.Reset);
            }
            UI_MainMediator.instance.Show();
            UI_FightMediator.instance.Hide();
        });
    }
    startCustomLevel(level_id) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.CreateLevel(ELoadTye.Try, level_id);
            this.StartGame();
        });
    }
    startChallengeLevel(level_id, skin_id) {
        return __awaiter(this, void 0, void 0, function* () {
            UI_LoadMediator.instance.Show();
            yield this.player.Clear();
            yield this.player.ChangeSkin(skin_id);
            yield this.CreateLevel(ELoadTye.Try, level_id);
            yield this.player.SetToOne();
            yield this.player.UpdateIndexForce(0);
            UI_LoadMediator.instance.Hide();
            this.StartGame();
        });
    }
    Clear() {
        GlobalUnit.StopScene();
        this.level.Clear();
        this.player.Clear();
        this.pet.Destroy();
    }
    CreateLevel(type, level_id = GameData.instance.levelId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (type != ELoadTye.Try) {
                GlobalUnit.dataManager.InitData();
            }
            // LTUI.ShowLoading("加载资源", true);
            UI_LoadMediator.instance.Show();
            P2Manager.instance.InitWorld();
            MaterialManager.instance.Clear();
            this.tryPetId = null;
            let urls = [];
            this.pet.SetPetId(GlobalUnit.dataManager.tryPetId);
            this.pet.PreLoad(urls);
            urls.length && (yield LTRes.LoadAsync(urls, UI_LoadMediator.instance.loadProgressHadler));
            urls = [];
            console.log(type.toString());
            switch (type) {
                case ELoadTye.Init:
                    yield this.level.CreateLevel();
                    yield this.player.ChangeSkin(GameData.instance.roleId);
                    break;
                case ELoadTye.Reset:
                    this.Clear();
                    yield this.player.ChangeSkin(GameData.instance.roleId);
                    yield this.level.CreateLevel(true);
                    break;
                case ELoadTye.Next:
                    this.Clear();
                    this.level.SetLevelId(GameData.instance.levelId);
                    this.level.PreLoad(urls);
                    yield LTRes.LoadAsync(urls, UI_LoadMediator.instance.loadProgressHadler);
                    yield this.player.ChangeSkin(GameData.instance.roleId);
                    yield this.level.CreateLevel();
                    break;
                case ELoadTye.Try:
                    this.state = EGameState.Ready;
                    this.player.state = EPlayerState.Idle;
                    this.Clear();
                    this.level.SetLevelId(level_id);
                    this.level.PreLoad(urls);
                    yield LTRes.LoadAsync(urls);
                    yield this.level.CreateLevel(true);
                    break;
            }
            UI_LoadMediator.instance.Hide();
            this.state = EGameState.Ready;
            //LTUI.HideLoading();
        });
    }
    OnWin() {
        return __awaiter(this, void 0, void 0, function* () {
            this.state = EGameState.Result;
            yield Awaiters.Seconds(2);
            LTPlatform.instance.recordManager.StopRecord(null);
            UI_FightMediator.instance.Hide();
            if (LTPlatform.instance.recordManager.supportRecord) {
                let openData = new LTG_Com_ShareVideoData();
                openData.camera = GlobalUnit.game.camera.camera;
                openData.onClosed = Laya.Handler.create(null, (code) => {
                    if (code == 1) {
                        GameData.instance.coinCount += 1000;
                        GameData.SaveToDisk();
                        LTUI.Toast("获得分享奖励 钞票：" + 1000);
                    }
                    this.resultType = EResultType.Win;
                    this.ShowResult();
                });
                openData.Send();
            }
            else {
                this.resultType = EResultType.Win;
                this.ShowResult();
            }
        });
    }
    OnFail() {
        return __awaiter(this, void 0, void 0, function* () {
            this.state = EGameState.Result;
            yield Awaiters.Seconds(1);
            this.resultType = EResultType.Fail;
            if (this.player.state == EPlayerState.EndFight) {
                this.ShowResult();
                return;
            }
            UI_ReviveMediator.instance.Show();
        });
    }
    ShowResult() {
        let closeed = Laya.Handler.create(this, () => {
            if (this.resultType == EResultType.Win) {
                UI_WinMediator.instance.Show();
            }
            else {
                UI_FailMediator.instance.Show();
            }
        });
        UI_SkillMediator.instance.Show(closeed);
    }
    CheckShowGet() {
        if (this.tryPetId) {
            if (!GlobalUnit.dataManager.CheckItemUnlock(1, this.tryPetId)) {
                let config = PetConfig.data[this.tryPetId];
                UI_GetMediator.instance.Show(config);
            }
        }
    }
    OnRevive() {
        this.player.OnRevive();
        this.state = EGameState.Fight;
    }
    Update(dt) {
        if (this.paused)
            return;
        switch (this.state) {
            case EGameState.Ready:
                this.player.Update(dt);
                break;
            case EGameState.Fight:
                UI_FightMediator.instance.UpdateBarPos();
                P2Manager.instance.Step(1 / 60);
                this.level.Update(dt);
                this.player.Update(dt);
                this.player.UpdateAmmo(dt);
                break;
            case EGameState.Fighted:
                break;
            case EGameState.Result:
                this.player.UpdateAmmo(dt);
                break;
        }
    }
    LateUpdate(dt) {
        if (this.paused)
            return;
        switch (this.state) {
            case EGameState.Ready:
                this.pet.Update(dt);
                break;
            case EGameState.Fight:
                this.camera.LateUpdate(dt);
                if (this.level.LateUpdate(dt)) {
                    this.OnWin();
                    return;
                }
                this.pet.Update(dt);
                if (!this.player.LateUpdate(dt)) {
                    this.OnFail();
                    return;
                }
                break;
            case EGameState.Fighted:
                break;
            case EGameState.Result:
                break;
        }
    }
    Pause() {
        this.paused = true;
    }
    Resume() {
        this.paused = false;
    }
}
